module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-steak@3x-72cbe78b9dd0b4f14acd63110d66e2ea.png";